// Resolved *.mcmail.ng workspace, captured by the boot-time tenant gate BEFORE
// any login. Lets pre-auth surfaces (the login screen) show the owner's name.
// Null on non-tenant hosts (webmail.mckodev.com.ng, custom CNAME domains).
let _workspace = null;

export const tenant = {
  set: (w) => { _workspace = w && w.name ? { domain: w.domain, name: w.name } : null; },
  get: () => _workspace,
  // Convenience: the owner/workspace name, or null.
  name: () => _workspace?.name ?? null,
};
